export default __webpack_public_path__ + "static/media/dashboard_setting_icon.af1a31c3.svg";